import ContractorUserName from "./ContractorUserName";
import ContractorUserLink from "./ContractorUserLink";

import ContractorName from "../../../../timber/components/contractor/ContractorDetail/ContractorName";
import ContractorLink from "../../../../timber/components/contractor/ContractorDetail/ContractorLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ContractorUserDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="ContractorUser-detail-title"
                    >
                        { label || t`Contractor User` }: <ContractorUserName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="ContractorUser-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="ContractorUser-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } data-testid="email-label" sx={{ textAlign: "left" }}><Trans>Email</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="email-value" sx={{ textAlign: "left" }}>{ data.email || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="name-label" sx={{ textAlign: "left" }}><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="name-value" sx={{ textAlign: "left" }}>{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="description-label" sx={{ textAlign: "left" }}><Trans>Description</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="description-value" sx={{ textAlign: "left" }}>{ data.description || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentLogCode-label" sx={{ textAlign: "left" }}><Trans>Shipment Log Code</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentLogCode-value" sx={{ textAlign: "left" }}>{ data.shipmentLogCode || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentLogCounter-label" sx={{ textAlign: "left" }}><Trans>Shipment Log Counter</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentLogCounter-value" sx={{ textAlign: "left" }}>{ data.shipmentLogCounter || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentCordwoodCode-label" sx={{ textAlign: "left" }}><Trans>Shipment Cordwood Code</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentCordwoodCode-value" sx={{ textAlign: "left" }}>{ data.shipmentCordwoodCode || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="shipmentCordwoodCounter-label" sx={{ textAlign: "left" }}><Trans>Shipment Cordwood Counter</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="shipmentCordwoodCounter-value" sx={{ textAlign: "left" }}>{ data.shipmentCordwoodCounter || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="userType-label" sx={{ textAlign: "left" }}><Trans>User Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="userType-value" sx={{ textAlign: "left" }}>{ toStringUserType(data.userType) || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="contractorId-label" sx={{ textAlign: "left" }}><Trans>Contractor</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="contractorId-value" sx={{ textAlign: "left" }}>{ data.contractorId ? (<ContractorLink id={ data.contractorId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default ContractorUserDetail;
